function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-circle-download");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.99991,
  cy: 21.99997,
  r: 22,
  fill: "#ededed"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 16.99991,
  y1: 29,
  x2: 26.99991,
  y2: 29,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

var _ref5 = /*#__PURE__*/React.createElement("polyline", {
  points: "17 20 22 25 27 20",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 21.99991,
  y1: 13,
  x2: 21.99991,
  y2: 24,
  fill: "none",
  stroke: "#333",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.25
});

const SvgCircleDownload = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea4426f3-9d79-40b9-bc95-884b2f610380",
    "data-name": "Layer 1",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-download.f84f291f.svg";
export { ForwardRef as ReactComponent };